import React from 'react';
import { MdChevronRight, MdLogout } from "react-icons/md";

const Sidebar = ({
  sidebarCollapsed,
  isMobile,
  isTablet,
  sidebarHidden,
  allowedNavGroups,
  activeMenu,
  expandedMenus,
  toggleSubMenu,
  handleMenuClick,
  userRole,
  handleLogout
}) => {
  return (
    <aside
      className={`sidebar-container fixed top-0 left-0 h-full flex flex-col transition-all duration-300 ${sidebarCollapsed ? 'w-20' : 'w-[280px]'} ${(isMobile || isTablet) ? (sidebarHidden ? '-translate-x-full' : 'translate-x-0') : 'translate-x-0'}`}
      style={{ zIndex: 100 }}
    >
      {/* Logo */}
      <div className={`flex items-center space-x-3 ${sidebarCollapsed && !isMobile ? 'p-4 justify-center' : 'p-6'}`}>
        <div className="flex-shrink-0 w-11 h-11 bg-teal-600 rounded-xl flex items-center justify-center shadow-lg shadow-teal-100 logo-glow transition-transform hover:scale-105">
          <img src="/logo.png" alt="Logo" className="w-7 h-7 object-contain brightness-0 invert" />
        </div>
        {!sidebarCollapsed && (
          <div className="overflow-hidden whitespace-nowrap animate-slide-in">
            <h1 className="text-[22px] font-black text-[#1e293b] tracking-tight leading-none">SURGIX</h1>
            <p className="text-[10px] font-extrabold text-[#0d9488] uppercase tracking-[0.2em] mt-1">MEDICAL HUB</p>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-8 sidebar-scroll overflow-y-auto">
        {allowedNavGroups.map((group) => (
          <div key={group.label} className="mb-8 last:mb-0">
            {(!sidebarCollapsed || isMobile || isTablet) && (
              <p className="nav-group-label">{group.label}</p>
            )}
            <ul className="space-y-1.5">
              {group.items.map((item) => {
                const isActive = activeMenu === item.name || item.subItems?.some(s => s.name === activeMenu);
                return (
                  <li key={item.name} className="sidebar-nav-item">
                    {item.subItems ? (
                      <>
                        <button
                          onClick={() => toggleSubMenu(item.name)}
                          className={`sidebar-link w-full ${sidebarCollapsed && !isMobile ? 'justify-center px-0' : ''} ${isActive ? 'active' : ''}`}
                        >
                          <item.icon className="sidebar-icon" />
                          {!sidebarCollapsed && <span className="flex-1 text-sm font-semibold text-left ml-3">{item.name}</span>}
                          {!sidebarCollapsed && <MdChevronRight className={`w-4 h-4 transition-transform duration-300 ${expandedMenus[item.name] ? 'rotate-90' : ''}`} />}
                        </button>
                        <div className={`submenu-container ${expandedMenus[item.name] && !sidebarCollapsed ? 'expanded' : ''}`}>
                          <ul className="submenu-list space-y-1">
                            {item.subItems.map(sub => (
                              <li key={sub.name}>
                                <button
                                  onClick={() => handleMenuClick(sub.name)}
                                  className={`submenu-item w-full text-left ${activeMenu === sub.name ? 'active' : ''}`}
                                >
                                  {sub.name}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <button
                        onClick={() => handleMenuClick(item.name)}
                        className={`sidebar-link w-full ${sidebarCollapsed && !isMobile ? 'justify-center px-0' : ''} ${activeMenu === item.name ? 'active' : ''}`}
                      >
                        <item.icon className="sidebar-icon mr-3" />
                        {!sidebarCollapsed && <span className="text-sm font-semibold">{item.name}</span>}
                      </button>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>

      {/* User profile + logout */}
      <div className="p-4 border-t border-slate-50 mt-auto">
        {!sidebarCollapsed && (
          <div className="user-profile-card mb-3">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0 w-9 h-9 rounded-xl avatar-badge text-white flex items-center justify-center font-bold text-base shadow-lg">
                {userRole?.[0]?.toUpperCase() || 'U'}
              </div>
              <div className="flex-1 overflow-hidden">
                <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest leading-none mb-1">Signed Level</p>
                <div className="flex items-center space-x-2">
                  <span className="text-[13px] font-bold text-slate-800 tracking-tight truncate">{userRole}</span>
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]"></div>
                </div>
              </div>
            </div>
          </div>
        )}
        <button
          onClick={handleLogout}
          className={`w-full flex items-center ${sidebarCollapsed && !isMobile ? 'justify-center px-0' : 'space-x-3 px-4'} py-3.5 text-red-500 hover:bg-red-50 rounded-xl transition-all font-bold text-xs border border-transparent hover:border-red-100 uppercase tracking-widest`}
        >
          <MdLogout className="w-4 h-4 flex-shrink-0" />
          {!sidebarCollapsed && <span>Sign Out</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
